import { createSelector } from '@reduxjs/toolkit';
import { selectStrategyAssociations, selectStrategy } from '../../store/selectors';

export const selectAssociations = createSelector(selectStrategyAssociations, (listState) => listState.associations);

export const selectStrategyCommon = createSelector(selectStrategy, (strategyState) => strategyState.common);
export const selectStrategyComposition = createSelector(selectStrategyCommon,(common) => common.strategyDashboard);
